import React from "react";

// import { useTranslation } from 'react-i18next';
import Balancer from "react-wrap-balancer";

import { useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";

const explanation = {
  "FACTURA TRIMISA":
    "raspuns cu factura originala si semnatura MF, transmis in urma transmiterii unei facturi, daca este validata de sistem",
  "FACTURA PRIMITA":
    "factura primita in calitate de cunparator de la un emitent care a folosit sistemul national privind factura electronica RO e-factura",
  "ERORI FACTURA":
    "raspuns cu erorile si semnatura MF, livrat in urma transmiterii unei facturi, daca NU este validata de sistem",
};

export const SPVDetails = () => {
  // const { t } = useTranslation();
  const { currentRecord } = useFxSelector(schema.uiSpvMain.select);
  return (
    <div className="notes2">
      <Balancer>{currentRecord?.QDETAILS}</Balancer>
    </div>
  );
};

export const SPVExplanations = () => {
  // const { t } = useTranslation();
  const { currentRecord } = useFxSelector(schema.uiSpvMain.select);
  return (
    <div className="notes2">
      <Balancer>{explanation?.[currentRecord?.QRESULT_TYPE] || "..."}</Balancer>
    </div>
  );
};

//todo: https://github.com/VldMrgnn/jk-react-app/issues/89 missing details information on new spv message
